// Tutorial Post-Processing System
// Allows modifying piece properties after FEN loading
// This enables setting hasMoved, laned, and other piece-specific states

export interface PieceModification {
  /** Target piece type (e.g. 'Rhino', 'Bear') */
  pieceType: string;
  /** Target piece side ('light' or 'dark') */
  side: 'light' | 'dark';
  /** Properties to modify on the piece */
  properties: {
    hasMoved?: boolean;
    laned?: boolean;
    poisoned?: boolean;
    entangled?: boolean;
    shadowed?: boolean;
    isKing?: boolean;
    // Add other piece properties as needed
  };
  /** Optional: Only modify pieces at specific positions */
  position?: {
    row?: number;
    col?: number;
  };
  /** Optional: Description for debugging */
  description?: string;
}

export interface TutorialPostProcessing {
  /** List of piece modifications to apply */
  modifications: PieceModification[];
}

/**
 * Apply post-processing modifications to pieces after FEN is loaded
 * @param gameState The game state with loaded pieces
 * @param postProcessing The modifications to apply
 */
export function applyTutorialPostProcessing(
  gameState: any,
  postProcessing: TutorialPostProcessing
): void {
  
  for (const modification of postProcessing.modifications) {
    let modifiedCount = 0;
    
    // Search the board for matching pieces
    for (let row = 0; row < gameState.board.length; row++) {
      for (let col = 0; col < gameState.board[row].length; col++) {
        const square = gameState.board[row][col];
        
        if (!square.Pieces) continue;
        
        for (const piece of square.Pieces) {
          // Check if piece matches the modification criteria
          const matchesType = piece.type === modification.pieceType;
          const matchesSide = piece.isLight === (modification.side === 'light');
          const matchesPosition = !modification.position || 
            (modification.position.row === undefined || modification.position.row === row) &&
            (modification.position.col === undefined || modification.position.col === col);
          
          if (matchesType && matchesSide && matchesPosition) {
            // Apply the property modifications
            for (const [property, value] of Object.entries(modification.properties)) {
              if (value !== undefined) {
                (piece as any)[property] = value;
              }
            }
            
            modifiedCount++;
            
            // If description is provided, log it
            if (modification.description) {
            }
          }
        }
      }
    }
    
  }
}